export const SETSTAFFDETAIL = 'SETSTAFFDETAIL'
